import type { DefesaCredito, ItemTriagemDefesaCredito } from './useTriagemDefesaCredito';

export type TentativaCotacao = DefesaCredito & { ids: string[]; itensIds: string[] };
export type CotacaoCredito = { chave: string; principal: ItemTriagemDefesaCredito; itens: ItemTriagemDefesaCredito[]; tentativas: TentativaCotacao[]; incompleta: boolean;
  /** Horas desde a última tentativa. A Claro leva até 24h para avaliar: passou
   *  disso, a cotação precisa de tentativa NOVA — motivo e defesa outra vez. */
  horasUltimaTentativa: number | null };

/** A Claro leva até 24h para avaliar a tentativa. Passou disso sem retorno, a
 *  cotação precisa de tentativa NOVA — motivo do reprovo e defesa outra vez. */
export const PRAZO_CLARO_HORAS = 24;

export function cicloDaTentativa(horas: number | null): { vencida: boolean; texto: string } {
  if (horas === null) return { vencida: true, texto: 'Sem tentativa — registrar motivo e defesa' };
  if (horas < PRAZO_CLARO_HORAS) return { vencida: false, texto: `Claro avaliando · faltam ${Math.max(1, Math.ceil(PRAZO_CLARO_HORAS - horas))}h` };
  const dias = Math.floor(horas / 24);
  return { vencida: true, texto: dias >= 1 ? `24h vencidas há ${dias}d — nova tentativa` : '24h vencidas — nova tentativa' };
}

/** Cotação só é identidade dentro do pedido/cliente. Sem número, agrupa visualmente
 * a pendência do pedido; ações de cotação ficam bloqueadas até identificar o vínculo. */
export function agruparCredito(itens: ItemTriagemDefesaCredito[]): CotacaoCredito[] {
  const grupos = new Map<string, CotacaoCredito>();
  for (const item of itens) {
    const chave = JSON.stringify([item.cnpj, item.pedido_id, item.numero_cotacao_operadora || null]);
    if (!grupos.has(chave)) grupos.set(chave, { chave, principal: item, itens: [], tentativas: [], incompleta: false, horasUltimaTentativa: null });
    grupos.get(chave)!.itens.push(item);
  }
  for (const grupo of grupos.values()) {
    const tentativas = new Map<string, TentativaCotacao>();
    for (const item of grupo.itens) for (const defesa of item.defesas) {
      // Legado sem identificador compartilhado: só condensa cópias idênticas entre itens.
      // Se a mesma linha repetiu número no dia, continua sendo outra tentativa.
      const base = JSON.stringify([defesa.tentativa_id || defesa.data_defesa?.slice(0, 10), defesa.numero_defesa, defesa.status, defesa.motivo_reprovacao, defesa.observacao]);
      let chave = base;
      if (tentativas.get(chave)?.itensIds.includes(item.item_id)) chave = `${base}:${defesa.id}`;
      const atual = tentativas.get(chave);
      if (atual) { atual.ids.push(defesa.id); atual.itensIds.push(item.item_id); }
      else tentativas.set(chave, { ...defesa, ids: [defesa.id], itensIds: [item.item_id] });
    }
    grupo.tentativas = [...tentativas.values()].sort((a, b) => b.data_defesa.localeCompare(a.data_defesa));
    const ultima = grupo.tentativas[0];
    const quando = ultima?.created_at || ultima?.data_defesa || null;
    grupo.horasUltimaTentativa = quando ? (Date.now() - new Date(quando).getTime()) / 3600000 : null;
    grupo.incompleta = grupo.itens.some(i => !i.credito_motivo_reprovacao?.trim()
      || i.defesas.some(d => !d.motivo_reprovacao?.trim() || !d.observacao?.trim()));
  }
  return [...grupos.values()];
}
